// extracted by mini-css-extract-plugin
export var container = "_vf-0";
export var table = "_vf-2";
export var tableWrapper = "_vf-1";